import script from "./EffectControlsPanelHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./EffectControlsPanelHeader.vue?vue&type=script&setup=true&lang=ts"

import "./EffectControlsPanelHeader.vue?vue&type=style&index=0&id=30f0fe8f&lang=scss"

const __exports__ = script;

export default __exports__